import axios from "axios";

export default {
    testConnection: async (companyId, agreementToken) => {
        await axios.post("/import/economic/test_connection/", {
            account_id: companyId,
            agreement_grant_token: agreementToken
        })
    },
    startImport: async (companyId) => {
        await axios.post(`/import/economic/${companyId}`)
    },
    getState: async (companyId) => {
        const {data} = await axios.get(`/import/economic/state/${companyId}`)
        return data
    }
}
